<template>
  <v-app :class="['ng-layout', 'ng-entry-layout-centered']">
    <v-main class="main pa-0">
      <div class="d-flex flex-column ng-entry-layout-centered__wrapper">
        <router-link
          v-if="isRoutingEnabled"
          class="ng-entry-layout-centered__logo nolink"
          to="/"
        >
          <app-logo
            :mode="$vuetify.breakpoint.smAndUp ? 'light' : 'default'"
            is-non-adaptive
          />
        </router-link>
        <a v-else class="ng-entry-layout-centered__logo nolink" href="/">
          <app-logo
            :mode="$vuetify.breakpoint.smAndUp ? 'light' : 'default'"
            is-non-adaptive
          />
        </a>
        <div class="ng-entry-layout-centered__content">
          <slot></slot>
        </div>
      </div>
    </v-main>
    <slot name="footer">
      <app-footer
        fluid
        :view="config.footerView || 'small'"
        :menu-items="config.bottomMenuItems"
      >
      </app-footer>
    </slot>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import AppLogo from '../components/AppLogo/AppLogo.vue';
import AppFooter from '../components/AppFooter/AppFooter.vue';

export default {
  name: 'EntryLayoutCentered',
  components: { AppFooter, AppLogo },
  props: {
    isRoutingEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(['baseApp']),
    config() {
      return this.baseApp.config;
    },
  },
};
</script>

<style lang="scss" scoped>
.ng-entry-layout-centered {
  &__content {
    width: 100%;
    padding: 24px;
    z-index: 2;
    margin-left: auto;
    margin-right: auto;
    max-width: 600px;
    background-color: #fff;
    border-radius: $border-radius-root;

    :deep(h1) {
      margin-top: 0;
      font-weight: 500;
    }
  }

  &__logo {
    margin-bottom: 32px;
    margin-top: 32px;
    padding-left: 24px;

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
      padding-left: 0;
    }

    :deep(.logo-pic) {
      width: 100px;

      @media (min-width: map-get($grid-breakpoints, 'sm')) {
        width: auto;
      }
    }
  }

  .main {
    min-height: 100%;
  }

  :deep(.footer) {
    margin-top: -$footer-height;

    .footer__container-1 {
      @media (min-width: map-get($grid-breakpoints, 'sm')) {
        color: rgba(255, 255, 255, 0.64);
      }
      background-color: transparent;
    }

    @media (min-width: map-get($grid-breakpoints, 'sm')) {
      a {
        color: rgba(255, 255, 255, 0.64);
        border-bottom-color: rgba(255, 255, 255, 0.24);

        &:hover {
          color: rgb(255, 255, 255);
        }
      }
    }
  }
}

.ng-entry-layout-centered__wrapper {
  min-height: 100vh;
  width: 100%;
  padding-bottom: 60px;

  @media (min-width: map-get($grid-breakpoints, 'sm')) {
    justify-content: center;
    align-items: center;
    background: url('../assets/img/auth_bg.jpg') left top no-repeat #2661c2;
    background-size: cover;
  }

  @media (max-height: 500px) {
    min-height: 500px;
  }
}
</style>
